var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticClass:"coupon-selector",attrs:{"value":_vm.couponCode,"filterable":"","placeholder":"เลือก Coupon"},on:{"input":_vm.handleChangeCoupon}},_vm._l((_vm.couponOptions),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.textDiscount,"value":item.id}},[_vm._v(_vm._s(item.textDiscount)+"\n  ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }